var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"is-small"},[_c('ui-page-hero',{attrs:{"title":"Configuration"}}),_c('ChannelSettings')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }